import { render, staticRenderFns } from "./checkbox-custom-button.vue?vue&type=template&id=04bb1c89&scoped=true"
import script from "./checkbox-custom-button.vue?vue&type=script&lang=js"
export * from "./checkbox-custom-button.vue?vue&type=script&lang=js"
import style0 from "./checkbox-custom-button.vue?vue&type=style&index=0&id=04bb1c89&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb1c89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bb1c89')) {
      api.createRecord('04bb1c89', component.options)
    } else {
      api.reload('04bb1c89', component.options)
    }
    module.hot.accept("./checkbox-custom-button.vue?vue&type=template&id=04bb1c89&scoped=true", function () {
      api.rerender('04bb1c89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/form-elements/checkbox-custom-button.vue"
export default component.exports